import React from 'react'
import { Icon } from 'react-icons-kit'
import { iosArrowBack } from 'react-icons-kit/ionicons'

export default (props) => (
  <button
    {...props}
    className="flex items-center gap-2 text-primary hover:text-primary-dark transition-colors duration-200 font-medium"
  >
    <span className="flex items-center">
      <Icon icon={iosArrowBack} size={24} />
    </span>
    {props.children}
  </button>
)
